<template>
  <v-app>
    <v-main>
      <div class="app-background" v-if="getBackgroundImage()" :style="{ 'background-image': 'url(' + getBackgroundImage() + ')' }">
      </div>
      <CardList/>
    </v-main>
  </v-app>
</template>

<script>
import CardList from './components/CardList';

export default {
  name: 'App',

  components: {
    CardList,
  },

  data: () => ({
    //
  }),
  methods: {
    getBackgroundImage() {
        if (this.$store.state.backgroundImage) {
            return this.$store.state.backgroundImage;
        }
        return '';
    },
  }
};
</script>

<style lang="scss" scoped>
.app-background {
  background-repeat: repeat;
  width: 100vw;
  height: 100%;
  position: absolute;
}
</style>